import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=065fdc65&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=065fdc65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fdc65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
